<template lang="html">
  <v-container grid-list-md justify-center mt-1 pt-0>
    <div style="margin-top: 17rem !important" v-if="isLoading">
      <v-layout row wrap flex justify-center align-center fill-height>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-layout>
    </div>
    <div
      style="margin-top: 15rem !important"
      v-if="!isLoading && listUserPlant.length === 0"
    >
      <v-layout row wrap flex justify-center align-center>
        <span class="display-1 font-weight-bold"
          >ยังไม่มีบันทึกการปลูกต้นไม้</span
        >
      </v-layout>
      <v-layout row wrap justify-center>
        <v-flex xs6 md2>
          <div class="ta-c">
            <v-btn color="primary" round block class="mx-0" @click="addTree()"
              >เพิ่มการปลูกต้นไม้</v-btn
            >
          </div>
        </v-flex>
      </v-layout>
    </div>

    <v-container v-if="!isLoading && listUserPlant.length !== 0" class="mt-0">
      <v-layout row wrap justify-space-between align-center mb-2>
        <div>
          <span class="headline font-weight-bold">ต้นไม้ของฉัน</span><br />
        </div>
        <div class="ta-c">
          <v-btn color="primary" round class="mx-0" @click="addTree()"
            >เพิ่มการปลูกต้นไม้</v-btn
          >
        </div>
      </v-layout>
      <!-- <pre>{{ listUserPlant }}</pre> -->

      <v-card flat>
        <v-card-text>
          <v-layout v-resize="onResize" column>
            <v-data-table
              :headers="headers"
              :items="listUserPlant"
              item-key="user_plant_id"
              hide-actions
              :loading="loading"
              :pagination.sync="pagination"
              ref="dTable"
              :hide-headers="isMobile"
              :class="{ mobile: isMobile }"
            >
              <template v-slot:items="props">
                <!-- <tr>{{props}}</tr> 
                  <tr>{{user_plant_id}}</tr>  -->
                <tr v-if="!isMobile">
                  <td class="text-xs-left">
                    {{ props.index + 1 }}
                  </td>
                  <td class="text-xs-left">
                    {{ formatDate(props.item.date_planting) }}
                  </td>
                  <td class="text-xs-left">{{ props.item.plant_name }}</td>
                  <td class="text-xs-left">{{ props.item.amount }}</td>
                  <td
                    class="text-xs-left"
                    v-if="props.item.province_name !== 'กรุงเทพมหานคร'"
                  >
                    ตำบล{{ props.item.tambon_name }} อำเภอ{{
                      props.item.amphoe_name
                    }}
                    จังหวัด{{ props.item.province_name }}
                  </td>
                  <td
                    class="text-xs-left"
                    v-if="props.item.province_name === 'กรุงเทพมหานคร'"
                  >
                    แขวง{{ props.item.tambon_name }} เขต{{
                      props.item.amphoe_name
                    }}
                    จังหวัด{{ props.item.province_name }}
                  </td>
                  <td class="text-xs-left">
                    {{ props.item.department_name }}
                    <span
                      v-if="props.item.department_id == 1"
                      style="font-size: 14px"
                      >- {{ props.item.sub_department_name_level1 }} -
                      {{ props.item.sub_department_name_level2 }}</span
                    >
                    <span
                      v-if="
                        props.item.other !== '' && props.item.department_id == 4
                      "
                      >- {{ props.item.other }}</span
                    >
                  </td>
                  <td class="text-xs-left" v-if="props.item.note !== ''">
                    {{ props.item.note }}
                  </td>
                  <td class="text-xs-left" v-if="props.item.note === ''">-</td>
                  <td class="text-xs-right" style="white-space: nowrap">
                    <!-- <v-btn icon> -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on">
                          <v-icon
                            @click.stop.prevent="
                              editTree(
                                props.item.date_planting,
                                props.item.plant_id,
                                props.item.user_plant_id,
                                props.item.amount,
                                props.item.latitude,
                                props.item.longitude,
                                props.item.province_id,
                                props.item.province_name,
                                props.item.amphoe_id,
                                props.item.amphoe_name,
                                props.item.tambon_id,
                                props.item.tambon_name,
                                props.item.department_id,
                                props.item.sub_department_id_level2,
                                props.item.sub_department_name_level2,
                                props.item.parent_department_id,
                                props.item.other,
                                props.item.note
                              )
                            "
                            color="blue-grey"
                            class="ml-5"
                            >edit</v-icon
                          >
                        </v-btn>
                      </template>
                      <span>แก้ไขข้อมูลต้นไม้</span>
                    </v-tooltip>
                    <!-- </v-btn> -->
                    <!-- <v-btn icon> -->
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn icon dark v-on="on">
                          <v-icon
                            @click.stop.prevent="
                              deleteItem(props.item.user_plant_id)
                            "
                            class=""
                            color="red"
                          >
                            delete
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>ลบข้อมูลต้นไม้</span>
                    </v-tooltip>
                    <!-- </v-btn> -->
                  </td>
                </tr>
                <tr @click="props.expanded = !props.expanded" v-else>
                  <td>
                    <ul class="flex-content">
                      <li class="flex-item" data-label="ครั้งที่">
                        {{ props.index + 1 }}
                      </li>
                      <li class="flex-item" data-label="ปลูกวันที่">
                        {{ formatDate(props.item.date_planting) }}
                      </li>
                      <li class="flex-item" data-label="ชนิดไม้">
                        {{ props.item.plant_name }}
                      </li>
                      <li class="flex-item" data-label="จำนวน">
                        {{ props.item.amount }} ต้น
                      </li>
                      <li
                        class="flex-item"
                        data-label="ปลูกที่"
                        v-if="props.item.province_name !== 'กรุงเทพมหานคร'"
                      >
                        ตำบล{{ props.item.tambon_name }} อำเภอ{{
                          props.item.amphoe_name
                        }}
                        จังหวัด{{ props.item.province_name }}
                      </li>
                      <li
                        class="flex-item"
                        data-label="ปลูกที่"
                        v-if="props.item.province_name === 'กรุงเทพมหานคร'"
                      >
                        แขวง{{ props.item.tambon_name }}
                        {{ props.item.amphoe_name }} จังหวัด{{
                          props.item.province_name
                        }}
                      </li>
                      <li class="flex-item" data-label="ได้รับต้นไม้จาก">
                        {{ props.item.department_name }}
                        <span
                          v-if="props.item.department_id == 1"
                          style="font-size: 14px"
                          >- {{ props.item.sub_department_name_level1 }} -
                          {{ props.item.sub_department_name_level2 }}</span
                        >
                        <span v-if="props.item.other !== ''"
                          >- {{ props.item.other }}</span
                        >
                      </li>
                      <li
                        class="flex-item"
                        data-label="บันทึกเพิ่มเติม"
                        v-if="props.item.note !== ''"
                      >
                        {{ props.item.note }}
                      </li>
                      <li
                        class="flex-item"
                        data-label="บันทึกเพิ่มเติม"
                        v-if="props.item.note === ''"
                      >
                        -
                      </li>
                      <span
                        class="flex-item"
                        style="display: flex; padding-right: 0 !important"
                      >
                        <div
                          style="
                            width: 100%;
                            justify-content: flex-end;
                            text-align: right;
                          "
                        >
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon dark v-on="on">
                                <v-icon
                                  @click.stop.prevent="
                                    editTree(
                                      props.item.date_planting,
                                      props.item.plant_id,
                                      props.item.user_plant_id,
                                      props.item.amount,
                                      props.item.latitude,
                                      props.item.longitude,
                                      props.item.province_id,
                                      props.item.province_name,
                                      props.item.amphoe_id,
                                      props.item.amphoe_name,
                                      props.item.tambon_id,
                                      props.item.tambon_name,
                                      props.item.department_id,
                                      props.item.sub_department_id_level1,
                                      props.item.sub_department_id_level2,
                                      props.item.other,
                                      props.item.note
                                    )
                                  "
                                  color="blue-grey"
                                  class="ml-5"
                                  >edit</v-icon
                                >
                              </v-btn>
                            </template>
                            <span>แก้ไขข้อมูลต้นไม้</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn icon dark v-on="on">
                                <v-icon
                                  @click.stop.prevent="
                                    deleteItem(props.item.user_plant_id)
                                  "
                                  class=""
                                  color="red"
                                >
                                  delete
                                </v-icon>
                              </v-btn>
                            </template>
                            <span>ลบข้อมูลต้นไม้</span>
                          </v-tooltip>
                        </div>
                      </span>
                    </ul>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-container>
    <ModalAddTree ref="ModalAddTree" @fetch="queryListUserPlant()" />
    <ModalImages ref="ModalImages" />
    <ModalAddImage ref="ModalAddImage" @fetch="queryListUserPlant()" />
    <ModalEditTree ref="ModalEditTree" @fetch="queryListUserPlant()" />
  </v-container>
</template>

<script>
import ModalAddTree from "@/components/ModalAddTree";
import ModalEditTree from "@/components/ModalEditTree";
import ModalImages from "@/components/ModalImages";
import ModalAddImage from "@/components/ModalAddImage";
import { Decode } from "@/services";
// var _ = require("lodash");
// const Hashids = require("hashids");
export default {
  components: {
    ModalAddTree,
    ModalImages,
    ModalAddImage,
    ModalEditTree,
  },
  data() {
    return {
      search: "",
      Hashids: null,
      isMobile: false,
      text: "",
      loading: true,
      isLoading: true,
      expand: true,
      expaned: [],
      listUserPlant: [],
      card_id: "",
      // panel: [true, false, false],
      // panel2: [[true]],
      pagination: {
        sortBy: "date_planting",
        rowsPerPage: -1,
      },
      headers: [
        {
          text: "ครั้งที่",
          align: "left",
          sortable: true,
          value: "plant_time",
          width: "1",
          class: "font-weight-bold",
        },
        {
          text: "ปลูกวันที่",
          align: "left",
          sortable: false,
          value: "date_planting",
          width: "3",
          class: "font-weight-bold",
        },
        {
          text: "ชนิดไม้",
          align: "left",
          sortable: false,
          value: "plant_name",
          width: "3",
          class: "font-weight-bold",
        },
        {
          text: "จำนวน (ต้น)",
          align: "left",
          sortable: false,
          value: "amount",
          width: "1",
          class: "font-weight-bold",
        },
        {
          text: "สถานที่ปลูก",
          align: "left",
          sortable: false,
          value: "tambon_name",
          width: "3",
          class: "font-weight-bold",
        },
        {
          text: "ได้รับต้นไม้จาก",
          align: "left",
          sortable: false,
          value: "department_name",
          width: "2",
          class: "font-weight-bold",
        },
        {
          text: "บันทึกเพิ่มเติม",
          align: "left",
          sortable: false,
          value: "note",
          width: "2",
          class: "font-weight-bold",
        },
        {
          text: "",
          align: "left",
          sortable: false,
          value: "",
          width: "10",
          class: "font-weight-bold",
        },
      ],
      attachment: [],
      fullName: "",
      day: "",
      month: "",
      year: "",
      number: "",
      certificate: [],
      tiles: [
        { img: "facebook.svg", title: "Facebook" },
        { img: "twitter.svg", title: "Twitter" },
        { img: "line.svg", title: "Line" },
      ],
      sheet: false,
      name: "",
      company: "",
      nameCertificate: "",
      link: "",
      linkShare: "",
      linkCreatePdf: "",
      number_eng: "",
    };
  },
  created() {
    var token = Decode.decode(this.$cookies.get("token"));
    this.card_id = JSON.parse(token).card_id;

    // console.log('note' + this.fullName );
    // this.company = JSON.parse(company).company;
    // console.log(this.company);
    // if (this.company === "") {
    //   this.nameCertificate = this.fullName;
    // } else {
    //   this.nameCertificate = this.company;
    // }
    // console.log(this.company);
    this.isLoading = true;
    this.queryListUserPlant();
    // this.queryCertificate();
  },
  methods: {
    // createUrl() {
    //   var hash = new Hashids.default("registration number of user", 16);
    //   var number = hash.encode(this.number_eng);
    //   //this.linkCreatePdf = "http://localhost:5000/certificate/" + number + ".pdf";
    //   this.linkCreatePdf =
    //     "https://plant.forest.go.th/certificate/" + number + ".pdf";
    // },
    addTree() {
      this.$refs.ModalAddTree.openDialog();
    },
    editTree(
      date_planting,
      plant_id,
      user_plant_id,
      amount,
      latitude,
      longitude,
      province_id,
      province_name,
      amphoe_id,
      amphoe_name,
      tambon_id,
      tambon_name,
      department_id,
      sub_department_id_level2,
      sub_department_name_level2,
      parent_department_id,
      other,
      note
    ) {
      this.$refs.ModalEditTree.openDialog(
        date_planting,
        plant_id,
        user_plant_id,
        amount,
        latitude,
        longitude,
        province_id,
        province_name,
        amphoe_id,
        amphoe_name,
        tambon_id,
        tambon_name,
        department_id,
        sub_department_id_level2,
        sub_department_name_level2,
        parent_department_id,
        other,
        note
      );
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      var year_thai = parseInt(year) + 543;
      return `${day}-${month}-${year_thai}`;
    },
    // addImage(plant_name, user_plant_id, plant_id) {
    //   this.$refs.ModalAddImage.openDialog(plant_name, user_plant_id, plant_id);
    // },
    // thaiNumber(num) {
    //   var array = {
    //     "1": "๑",
    //     "2": "๒",
    //     "3": "๓",
    //     "4": "๔",
    //     "5": "๕",
    //     "6": "๖",
    //     "7": "๗",
    //     "8": "๘",
    //     "9": "๙",
    //     "0": "๐",
    //   };
    //   var str = num.toString();
    //   for (var val in array) {
    //     str = str.split(val).join(array[val]);
    //   }
    //   return str;
    // },
    // thaiMonth(month) {
    //   var array = {
    //     "1": "มกราคม",
    //     "2": "กุมภาพันธ์",
    //     "3": "มีนาคม",
    //     "4": "เมษายน",
    //     "5": "พฤษภาคม",
    //     "6": "มิถุนายน",
    //     "7": "กรกฎาคม",
    //     "8": "สิงหาคม",
    //     "9": "กันยายน",
    //     "10": "ตุลาคม",
    //     "11": "พฤศจิกายน",
    //     "12": "ธันวาคม",
    //   };
    //   var str = month.toString();
    //   for (var val in array) {
    //     str = str.split(val).join(array[val]);
    //   }
    //   return str;
    // },
    // queryCertificate() {
    //   this.isLoading = true;
    //   this.axios
    //     .post(process.env.VUE_APP_IPFLASK + "/queryCertificate", {
    //       card_id: this.card_id,
    //     })
    //     .then((response) => {
    //       this.certificate = response.data;
    //       // console.log(this.certificate);
    //       this.number = this.thaiNumber(this.certificate["0"].id);
    //       this.number_eng = this.certificate["0"].id;
    //       this.day = this.thaiNumber(this.certificate["0"].day);
    //       this.month = this.thaiMonth(this.certificate["0"].month);
    //       this.year = this.thaiNumber(this.certificate["0"].year);
    //       this.createUrl();
    //     });
    // },
    queryListUserPlant() {
      this.isLoading = true;
      this.axios
        .post(process.env.VUE_APP_IPFLASK + "/queryListUserPlant", {
          card_id: this.card_id,
        })
        .then((response) => {
          // console.log(response.data);
          if (response.data === "No data") {
            this.listUserPlant = [];
            this.isLoading = false;
          } else {
            this.listUserPlant = response.data;
            this.isLoading = false;
            this.loading = false;
            // this.panel = [true, false, false];
            // this.panel2 = [[true]];
            // setTimeout(() => this.expandAll(), 100);
          }
        });
    },
    // expandAll() {
    //   var i = 0;
    //   this.listUserPlant.forEach((userPlant) => {
    //     _.each(userPlant.year, (plantsInYear) => {
    //       plantsInYear.forEach((plant) => {
    //         // console.log(this.$refs.dTable);
    //         this.$set(this.$refs.dTable[i].expanded, plant.user_plant_id, true);
    //       });
    //       i++;
    //     });
    //   });
    // },
    getLinkImg(link) {
      return process.env.VUE_APP_IPFLASK + "/" + link;
    },
    // showImg(original_link) {
    //   this.$refs.ModalImages.openDialog(original_link);
    // },
    // deleteImg(plant_image_id) {
    //   this.$swal({
    //     title: "คุณต้องการลบรูปนี้ใช่หรือไม่",
    //     text: "",
    //     type: "warning",
    //     showCancelButton: true,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "ลบ",
    //     cancelButtonText: "ยกเลิก",
    //     reverseButtons: true,
    //   }).then((result) => {
    //     if (result.value) {
    //       this.axios
    //         .post(process.env.VUE_APP_IPFLASK + "/deleteUserPlantImage", {
    //           plant_image_id: plant_image_id,
    //         })
    //         .then((response) => {
    //           if (response.data === "Delete Success") {
    //             this.$swal("ลบรูปภาพเรียบร้อย", "", "success");
    //             this.queryListUserPlant();
    //           }
    //         });
    //     }
    //   });
    // },
    // changeImg(plant_image_id, user_plant_id, image_select) {
    //   if (image_select === 1) {
    //     return false;
    //   } else {
    //     this.$swal({
    //       title: "คุณต้องการนำรูปนี้เป็นรูปที่แสดงบนแผนที่ใช่หรือไม่",
    //       text: "",
    //       type: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#3085d6",
    //       cancelButtonColor: "#d33",
    //       confirmButtonText: "ตกลง",
    //       cancelButtonText: "ยกเลิก",
    //       reverseButtons: true,
    //     }).then((result) => {
    //       if (result.value) {
    //         this.axios
    //           .post(process.env.VUE_APP_IPFLASK + "/changeSelectedImage", {
    //             plant_image_id: plant_image_id,
    //             user_plant_id: user_plant_id,
    //           })
    //           .then((response) => {
    //             if (response.data === "Change Image Success") {
    //               this.$swal("เปลี่ยนรูปภาพเรียบร้อย", "", "success");
    //               this.queryListUserPlant();
    //             }
    //           });
    //       }
    //     });
    //   }
    // },
    getImgUrl(image) {
      return require("../assets/images/icon/" + image);
    },
    // showBottomSheet(plant_image_id) {
    //   this.sheet = true;
    //   this.plant_image_id = plant_image_id;
    //   var hashids = new Hashids.default();
    //   var plant_image_id_hashids = hashids.encode(this.plant_image_id);
    //   this.axios
    //     .get(process.env.VUE_APP_IPFLASK + "/share/" + plant_image_id_hashids)
    //     .then((response) => {
    //       // console.log(response.config.url);
    //       this.link = "https://plant.forest.go.th" + response.config.url;
    //       // console.log(this.link);
    //     });
    // },
    // gotoShareShowLink(social) {
    //   var hashtag = "#รวมใจไทยปลูกต้นไม้เพื่อแผ่นดิน";
    //   if (social === "Facebook") {
    //     (this.linkShare =
    //       "http://www.facebook.com/sharer.php?u=" +
    //       encodeURIComponent(this.link) +
    //       "&hashtag=" +
    //       encodeURIComponent(hashtag)),
    //       "sharer",
    //       "toolbar=0,status=0,width=200,height=200";
    //   } else if (social === "Twitter") {
    //     this.linkShare =
    //       "https://twitter.com/intent/tweet?url=" +
    //       encodeURIComponent(this.link) +
    //       "&hashtags=รวมใจไทยปลูกต้นไม้เพื่อแผ่นดิน";
    //   } else if (social === "Line") {
    //     this.linkShare =
    //       "https://social-plugins.line.me/lineit/share?url=" +
    //       encodeURIComponent(this.link) +
    //       "&text=" +
    //       encodeURIComponent(hashtag);
    //   }
    // },
    // gotoShare(social) {
    //   var hashtag = "#รวมใจไทยปลูกต้นไม้เพื่อแผ่นดิน";
    //   if (social === "Facebook") {
    //     (this.linkShare =
    //       "http://www.facebook.com/sharer.php?u=" +
    //       encodeURIComponent(this.link) +
    //       "&hashtag=" +
    //       encodeURIComponent(hashtag)),
    //       "sharer",
    //       "toolbar=0,status=0,width=200,height=200";
    //     this.sheet = false;
    //     // console.log(this.linkShare);
    //     return false;
    //   } else if (social === "Twitter") {
    //     this.linkShare =
    //       "https://twitter.com/intent/tweet?url=" +
    //       encodeURIComponent(this.link) +
    //       "&hashtags=รวมใจไทยปลูกต้นไม้เพื่อแผ่นดิน";
    //     this.sheet = false;
    //     // console.log(this.linkShare);
    //     return false;
    //   } else if (social === "Line") {
    //     this.linkShare =
    //       "https://social-plugins.line.me/lineit/share?url=" +
    //       encodeURIComponent(this.link) +
    //       "&text=" +
    //       encodeURIComponent(hashtag);
    //     this.sheet = false;
    //     // console.log(this.linkShare);
    //     return false;
    //   }
    // },
    deleteItem(user_plant_id) {
      this.$swal({
        title: "คุณต้องการลบการปลูกต้นไม้ครั้งนี้ใช่หรือไม่",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ลบ",
        cancelButtonText: "ยกเลิก",
        reverseButtons: true,
      }).then((result) => {
        // console.log(result);
        // console.log(user_plant_id);
        if (result.value) {
          this.axios
            .post(process.env.VUE_APP_IPFLASK + "/deleteUserPlantID", {
              user_plant_id: user_plant_id,
            })
            .then((response) => {
              if (response.data === "Delete User Plant ID Success") {
                this.$swal("ลบการปลูกต้นไม้เรียบร้อย", "", "success");
                this.queryListUserPlant();
              }
            });
        }
      });
    },
    onResize() {
      // console.log(window.innerWidth);
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
  },
};
</script>

<style scoped>
.plant {
  background-color: var(--v-primary-base) !important;
  font-size: 22px !important;
  height: 30px;
}

.header_plant {
  font-size: 20px;
  /* padding: 0px 15px 0 0 !important */
}
.header_plant_line {
  border-bottom: 1px solid rgba(0, 0, 0, 0.24);
}

.border-upload {
  border: 2px solid #c4c4c4;
  justify-content: center;
  display: flex;
  align-items: center;
  border-radius: 5px;
}

#fileInput {
  display: none;
}

#upload_tree .v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: transparent !important;
}

.table_img:not(:last-child) {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  padding-bottom: 10px !important;
}

.sub_header {
  background-color: var(--v-yellow-base) !important;
}
.plant_header {
  background-color: var(--v-primary-base) !important;
}

.plant_select {
  border: 2px solid var(--v-secondary-base) !important;
}

.plant_not_select {
  border: 1px solid #e6e6e6 !important;
}

@media only screen and (max-width: 768px) {
  .mobile table.v-table tr {
    max-width: 100%;
    position: relative;
    display: block;
  }

  .mobile table.v-table tr td {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #f5f5f5;
    height: auto;
    padding: 10px;
  }

  .mobile table.v-table tr td ul li:before {
    content: attr(data-label);
    padding-right: 0.5em;
    text-align: left;
    color: rgba(0, 0, 0, 0.54);
    font-weight: bold;
  }
  .v-datatable__actions__select {
    width: 50%;
    margin: 0px;
    justify-content: flex-start;
  }
  .mobile .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
    background: transparent;
  }

  td.v-datatable__expand-col {
    padding: 0 0px !important;
  }
  table.v-table tbody td:first-child {
    padding: 0 0px !important;
  }
}
.flex-content {
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

.flex-item {
  padding: 2px;
  width: 100%;
  /* font-weight: bold; */
}

.v-card {
  box-shadow: none;
}
</style>
